import { MainTab } from "./MainTab";

export default MainTab;